import React from "react";
import classNames from "classnames";
import { Link } from "../link";
import { normalizeRelativePath } from "../../utility/paths";
import BannerMenu from "./banner-menu";
import useBlockScroll from "../../hooks/use-block-scroll";

const SupportMenu = ({ supportoRef, supporto, newTopRightMenu }) => {
  const banners =
    newTopRightMenu && newTopRightMenu?.navigationMenuItems?.length
      ? newTopRightMenu.navigationMenuItems
          .filter((item) => item?.content && item?.content?.__typename === "LiferayBannerMenu")
          ?.slice(0, 2)
      : null;
  const columns =
    newTopRightMenu && newTopRightMenu?.navigationMenuItems?.length
      ? newTopRightMenu?.navigationMenuItems.filter(
          (item) =>
            item?.content &&
            item?.navigationMenuItems?.length &&
            item?.content?.__typename !== "LiferayBannerMenu" &&
            item?.content?.__typename !== "LiferayAcBannerMenu"
        )
      : null;

  const columnsFiltered = columns && !!banners ? columns?.slice(0, 3) : columns?.slice(0, 4);

  const fullWidthCheck = columnsFiltered?.length > 2 && banners?.length > 0;

  useBlockScroll(supporto);

  return (
    <div className={classNames("support-menu-link-wrapper", "w-100 d-none d-lg-block")}>
      <div className={`support-menu-link w-100 support-menu${supporto ? " open" : ""}`}>
        <div
          className={classNames(
            "support-menu__content justify-content-between",
            fullWidthCheck && "w-100"
          )}
        >
          <div ref={supportoRef} className="support-menu__content-container h-100">
            <div className="d-flex w-100">
              {columnsFiltered?.length > 0 && (
                <div
                  className={classNames(
                    "d-flex support-menu__category-wrapper",
                    columnsFiltered?.length === 3 &&
                      banners?.length > 0 &&
                      "support-menu__category-wrapper--max col-lg-6 col-xl-7",
                    "d-flex support-menu__category-wrapper",
                    columnsFiltered?.length === 1 && "support-menu__category-wrapper--one-banner",
                    columnsFiltered?.length === 2 &&
                      banners?.length > 0 &&
                      "support-menu__category-wrapper--two support-menu__category-wrapper--two-has-banner",
                    columnsFiltered?.length === 2 &&
                      !banners?.length > 0 &&
                      "support-menu__category-wrapper--two",
                    columnsFiltered?.length === 3 &&
                      !banners?.length > 0 &&
                      "support-menu__category-wrapper--three"
                  )}
                >
                  {columnsFiltered?.length > 0
                    ? columnsFiltered.map((item, index) => (
                        <div key={index} className="support-menu__category">
                          {!!item?.useCustomName && item?.name
                            ? item.name
                            : item.content?.liferayFields?.title}
                          <div className="support-menu__bar"></div>
                          <ul className="support-menu__list">
                            {item?.navigationMenuItems?.length > 0
                              ? item.navigationMenuItems.map((item, i) => (
                                  <li className="support-menu__list-item" key={i}>
                                    {item.content.slug ? (
                                      <Link
                                        to={normalizeRelativePath(item.content.slug)}
                                        target={
                                          item?.content?.target && item?.content?.target?.length > 0
                                            ? item?.content?.target[0]
                                            : ""
                                        }
                                        className="support-menu__link"
                                      >
                                        {!!item?.useCustomName && item?.name
                                          ? item.name
                                          : item.content?.liferayFields?.title}
                                      </Link>
                                    ) : item?.content?.externalLink ? (
                                      <a
                                        href={item.content.externalLink}
                                        target={
                                          item?.content?.target && item?.content?.target?.length > 0
                                            ? item?.content?.target[0]
                                            : ""
                                        }
                                        rel={
                                          item.content?.target[0] === "_blank"
                                            ? "noopnener noreferrer"
                                            : ""
                                        }
                                        className="support-menu__link"
                                      >
                                        {!!item?.useCustomName && item?.name
                                          ? item.name
                                          : item.content?.liferayFields?.title}
                                      </a>
                                    ) : null}
                                  </li>
                                ))
                              : null}
                          </ul>
                        </div>
                      ))
                    : null}
                </div>
              )}
              {banners?.length > 0 && (
                <div
                  className={classNames(
                    "d-flex flex-column support-menu__banner-container",
                    columnsFiltered?.length === 1 && banners?.length > 0 && "col-6",
                    ((columnsFiltered?.length > 2 && banners?.length > 0) ||
                      (columnsFiltered?.length > 2 && !banners?.length > 0)) &&
                      "col-lg-6 col-xl-5",
                    columnsFiltered?.length === 1 && "col-7",
                    columnsFiltered?.length === 3 &&
                      banners?.length > 0 &&
                      "support-menu__banner-container--max"
                  )}
                >
                  {banners?.length &&
                    banners.map((item, i) => (
                      <div key={i}>
                        <BannerMenu
                          bannerMenu={item.content}
                          key={i}
                          origin="new-menu"
                          count={banners?.length}
                        />
                        {banners.length === 2 && i === 0 && (
                          <div className="support-menu__bar-banner"></div>
                        )}
                      </div>
                    ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportMenu;
